export default "__VITE_ASSET__DaBJx0Bp__"